export const filters = [
  {
    name: "Nome",
    slug: "chars",
    value: "",
    initialValue: "",
    type: "string",
  },
  // {
  //   name: "Capital recomendado (R$)",
  //   slug: "sugg_capital",
  //   value: 0,
  //   initialValue: 0,
  //   min: 0,
  //   max: 10000,
  //   step: 1000,
  //   type: "range",
  // },
  // {
  //   name: "Perda máxima diária (R$)",
  //   slug: "max_daily_loss",
  //   value: 0,
  //   initialValue: 0,
  //   min: -2000,
  //   max: 0,
  //   step: 50,
  //   type: "range",
  // },
  // {
  //   name: "Ganho máximo diária (R$)",
  //   slug: "max_daily_gain",
  //   value: 0,
  //   initialValue: 0,
  //   min: 0,
  //   max: 2000,
  //   step: 50,
  //   type: "range",
  // },
  // {
  //   name: "Volume alocado",
  //   slug: "curr_volume",
  //   value: 100,
  //   initialValue: 100,
  //   min: 1,
  //   max: 100,
  //   step: 1,
  //   type: "range",
  // },
  // {
  //   name: "Retorno total (%)",
  //   slug: "profit",
  //   value: 0,
  //   initialValue: 0,
  //   min: 0,
  //   max: 2000,
  //   step: 50,
  //   type: "range",
  // },
  {
    name: "Ativo",
    slug: "strategy_symbol",
    items: [
      // { displayName: "WINFUT", value: "WINFUT" },
    ],
    active: [],
    type: "tagbox",
  },
  {
    name: "Desenvolvedor",
    slug: "strategy_developer",
    items: [
      // { displayName: "WINFUT", value: "WINFUT" },
    ],
    active: [],
    type: "tagbox",
  },
  {
    name: "Status",
    slug: "position_status",
    items: [
      { displayName: "Zerado", value: "ZERADO" },
      { displayName: "Posicionado", value: "POSICIONADO" },
    ],
    active: [],
    type: "tagbox",
  },
  {
    name: "Mercado",
    slug: "strategy_market",
    items: [
      { displayName: "Futuro", value: "FUTURES" },
      { displayName: "À vista", value: "EQUITIES" },
      { displayName: "Cripto", value: "CRIPTO" },
    ],
    active: [],
    type: "tagbox",
  },
  // {
  //   name: "Risco",
  //   slug: "strategy_risk",
  //   items: [
  //     { displayName: "Alto", value: "ALTO" },
  //     { displayName: "Médio", value: "MEDIO" },
  //     { displayName: "Baixo", value: "BAIXO" },
  //   ],
  //   active: [],
  //   type: "tagbox",
  // },
  // {
  //   name: "Nível",
  //   slug: "account_level",
  //   items: [
  //     { displayName: "Grátis", value: "FREE" },
  //     { displayName: "Basic", value: "BASIC" },
  //     { displayName: "Pro", value: "PRO" },
  //     { displayName: "Max", value: "MAX" },
  //     { displayName: "Assinatura", value: "SUBSCRIPTION" },
  //   ],
  //   active: [],
  //   type: "tagbox",
  // },
  // {
  //   name: "Timeframe",
  //   slug: "strategy_timeframe",
  //   items: [
  //     { displayName: "M1-M5", value: "M1_M5" },
  //     { displayName: "M6-M15", value: "M6_M15" },
  //     { displayName: "M20-H2", value: "M20_H2" },
  //     { displayName: "Outros", value: "outros" },
  //   ],
  //   active: [],
  //   type: "tagbox",
  // },
  {
    name: "Estilo",
    slug: "strategy_style",
    items: [
      { displayName: "Day trade", value: "DAY_TRADE" },
      { displayName: "Swing trade", value: "SWING_TRADE" },
    ],
    active: [],
    type: "tagbox",
  },
  {
    name: "Objetivos atingidos",
    slug: "objectives",
    items: [
      { displayName: "Ganho", value: "GAIN" },
      { displayName: "Perda", value: "LOSS" },
      { displayName: "Tempo", value: "TIME" },
      { displayName: "Limite", value: "LIMIT" },
    ],
    active: [],
    type: "tagbox",
  },
];

export const filtered = ({ filters, investment }) => {
  const filteredByText = (item) => {
    let filter = filters.find((item) => item.slug === "chars");
    if (!filter.value.length) return true;
    return (
      item.strategy_name
        .toUpperCase()
        .includes(
          filters.find((item) => item.slug === "chars").value.toUpperCase()
        ) ||
      item.strategy_developer
        .toUpperCase()
        .includes(
          filters.find((item) => item.slug === "chars").value.toUpperCase()
        )
    );
  };

  const filteredBySuggCapital = (item) => {
    let filter = filters.find((item) => item.slug === "sugg_capital");
    return item.min_capital >= filter.value;
  };

  const filteredByMaxDailyLoss = (item) => {
    let filter = filters.find((item) => item.slug === "max_daily_loss");
    return item.max_daily_loss <= filter.value;
  };

  const filteredByMaxDailyGain = (item) => {
    let filter = filters.find((item) => item.slug === "max_daily_gain");
    return item.max_daily_gain >= filter.value;
  };

  const filteredByAllocatedVolume = (item) => {
    let filter = filters.find((item) => item.slug === "curr_volume");
    return item.curr_volume <= filter.value;
  };

  const filteredByProfit = (item) => {
    return true;
  };

  const filteredBySymbol = (item) => {
    let filter = filters.find((item) => item.slug === "strategy_symbol");
    if (!filter.active.length) return true;
    return filter.active.includes(item.strategy_symbol);
  };

  const filteredByDeveloper = (item) => {
    let filter = filters.find((item) => item.slug === "strategy_developer");
    if (!filter.active.length) return true;
    return filter.active.includes(item.strategy_developer);
  };

  const filteredByPositionStatus = (item) => {
    let filter = filters.find((item) => item.slug === "position_status");
    if (!filter.active.length) return true;
    if (filter.active.includes("ZERADO")) {
      return item.position_status === "Zerado";
    }
    if (filter.active.includes("POSICIONADO")) {
      return item.position_status !== "Zerado";
    }
  };

  const filteredByMarket = (item) => {
    let filter = filters.find((item) => item.slug === "strategy_market");
    if (!filter.active.length) return true;
    return filter.active.includes(item.strategy_market.toUpperCase());
  };

  const filteredByRisk = (item) => {
    return true;
  };

  const filteredByPlan = (item) => {
    return true;
  };

  const filteredByTimeframe = (item) => {
    return true;
  };

  const filteredByStyle = (item) => {
    let filter = filters.find((item) => item.slug === "strategy_style");
    if (!filter.active.length) return true;
    return filter.active.includes(item.strategy_style);
  };

  const filteredByObjective = (item) => {
    let filter = filters.find((item) => item.slug === "objectives");
    if (!filter.active.length) return true;
    if (filter.active.includes("GAIN")) return item.mask_gain;
    if (filter.active.includes("LOSS")) return item.mask_loss;
    if (filter.active.includes("TIME")) return item.mask_time;
    if (filter.active.includes("LIMIT")) return item.mask_limit;
  };

  return investment
    .filter((item) => item.status !== "HIDDEN")
    .filter((item) => {
      return (
        filteredByText(item) &&
        // filteredBySuggCapital(item) &&
        // filteredByMaxDailyLoss(item) &&
        // filteredByMaxDailyGain(item) &&
        // filteredByAllocatedVolume(item) &&
        // filteredByProfit(item) &&
        filteredBySymbol(item) &&
        filteredByDeveloper(item) &&
        filteredByPositionStatus(item) &&
        filteredByMarket(item) &&
        // filteredByRisk(item) &&
        // filteredByPlan(item) &&
        // filteredByTimeframe(item) &&
        filteredByStyle(item) &&
        filteredByObjective(item)
      );
    });
};
